import { api } from "../config";

export const apiCallsNetworkTester = {

    FetchDevices: async (filters) => {
        try {          
            const fromDateTime = filters.fromDate;
            const response = await api.get(`RadioCoverage/tester/${filters.tester}`, {
                params: {
                    DateFrom: fromDateTime, 
                }
                });
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                throw error;
            }
        },

    
}